import AjaxResolver from 'owd/module/ajax';

export default class DefaultResolver extends AjaxResolver {
	shouldPushState() {
		return true;
	}

	pageIn() {
		const deferred = $.Deferred();
		
		$('video[autoplay]').each((index, video) => {
			video.play();
		});

		$('.logo').each(function() {
			var html = $(this).html();
			$(this).html(html);
		});

		$('.header').transition({
			opacity: 1
		}, 500, 'ease-out');

		$('.ajax-wrapper > *').transition({
			opacity: 1
		}, 500, 'ease-out', () => {
			// deferred.resolve();
		});

		
		$('.ajax-loader').transition({
			opacity: 0,
			visibility: 'hidden'
		}, 300, () => {
			deferred.resolve();
		});


		return deferred.promise();
	}

	pageOut() {
		const deferred = $.Deferred();


		// $('.header').transition({
		// 	opacity: 0
		// }, 250, 'ease-out');

		// $('.ajax-wrapper > *').transition({
		// 	opacity: 0
		// }, 250, 'ease-out', () => {
		// 	this.app.dom.$window.scrollTop(0);
		// 	deferred.resolve();
		// });

		$('.ajax-loader').transition({
			opacity: 1,
			visibility: 'visible'
		}, 300, () => {
			this.app.dom.$window.scrollTop(0);
			deferred.resolve();
		});


		return deferred.promise();
	}

	updateContent($loadedContent) {
		const deferred = $.Deferred();

		const $old = $('.ajax-wrapper');
		const $oldHeader = $('.header');
		const $oldMenu = $('.main-menu');
		const bodyClass = $loadedContent.find('.overall').data('body-class');
		const bodyTheme = $loadedContent.find('.overall').data('theme');

		$loadedContent.find('.ajax-wrapper > *, .header').css({
			opacity: 0
		});

		if (this.preventUpdateBodyClass !== true) {
			$('body').attr('class', bodyClass);
			$('body').attr('data-theme', bodyTheme);
		}

		const $new = $loadedContent.find('.ajax-wrapper');
		const $newHeader = $loadedContent.find('.header');
		const $newMenu = $loadedContent.find('.main-menu');

		$old.after($new);
		$oldHeader.after($newHeader);
		$oldMenu.after($newMenu);
		$old.remove();
		$oldHeader.remove();
		$oldMenu.remove();

		deferred.resolve([$old, $oldHeader, $oldMenu], [$new, $newHeader, $newMenu]);

		return deferred.promise();
	}
}
